import React from 'react'
import PropTypes from 'prop-types'
import { Hr, Margin, Panel, Text, Table } from 'shared/components'

import { AthleteFilters } from './components/filters'

const AthleteOverviewComponent = ({
  columns,
  loadAthletes,
  getTrProps,
  onSearch,
}) => (
  <Panel>
    <Margin tb={3}>
      <Text size={20} bold>
        Athletes
      </Text>
    </Margin>
    <Hr width="full" />
    <Margin tb={3}>
      <AthleteFilters debounce={250} onSearch={onSearch} />
    </Margin>
    <Table
      id="athlete-table"
      columns={columns}
      loadData={loadAthletes}
      getTrProps={getTrProps}
    />
  </Panel>
)

AthleteOverviewComponent.propTypes = {
  columns: PropTypes.arrayOf(PropTypes.shape()),
  loadAthletes: PropTypes.func.isRequired,
  getTrProps: PropTypes.func.isRequired,
  onSearch: PropTypes.func.isRequired,
}

export default AthleteOverviewComponent
